fragment ProductReviewsFragment on productReviews_Entry {
  typeHandle
  shopifyHandle
}
